export enum InputType {
  TextField = 'text_field',
  TextArea = 'text_area',
  SelectBox = 'select_box',
  RadioButton = 'radio_button',
}

export enum ValidationType {
  None = 'none',
  Alphanumeric = 'alphanumeric',
  Numeric = 'numeric',
  Phone = 'phone',
  Email = 'email',
  Katakana = 'katakana',
}

export interface MerchantPurchaseCustomFields {
  id: number;
  input_type: InputType;
  validation_type: ValidationType;
  label: string;
  value_options?: string[];
  description: string;
  required: boolean;
  default_value: string;
}

export interface MerchantPurchaseCustomFieldsData {
  customer_custom_fields?: MerchantPurchaseCustomFields[];
}
